import { render } from "./block-rule-list-drawer.vue?vue&type=template&id=f4fe008c&scoped=true&ts=true"
import script from "./block-rule-list-drawer.vue?vue&type=script&lang=ts"
export * from "./block-rule-list-drawer.vue?vue&type=script&lang=ts"

import "./block-rule-list-drawer.vue?vue&type=style&index=0&id=f4fe008c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4fe008c"]])

export default __exports__